var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5V5.32845C10 4.91968 10 4.7153 9.9239 4.53153C9.84775 4.34776 9.70325 4.20325 9.4142 3.91422L7.04595 1.54594C6.7965 1.2965 6.6718 1.17177 6.51725 1.09787C6.4851 1.0825 6.4522 1.06886 6.4186 1.05701C6.25705 1 6.0807 1 5.7279 1C4.10541 1 3.29415 1 2.74466 1.44304C2.63365 1.53254 2.53254 1.63366 2.44303 1.74467C2 2.29416 2 3.10541 2 4.72792V6.5M6.5 1.25V1.5C6.5 2.91421 6.5 3.62132 6.93935 4.06066C7.3787 4.5 8.0858 4.5 9.5 4.5H9.75",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 8H8.625C8.34885 8 8.125 8.22385 8.125 8.5V9.5M8.125 9.5V11M8.125 9.5H9.625M2.125 11V9.75M2.125 9.75V8H3C3.48325 8 3.875 8.39175 3.875 8.875C3.875 9.35825 3.48325 9.75 3 9.75H2.125ZM5.125 8H5.875C6.4273 8 6.875 8.4477 6.875 9V10C6.875 10.5523 6.4273 11 5.875 11H5.125V8Z",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.6b8bd835421f34a839cc6ef5c5132f29.svg";
export { ForwardRef as ReactComponent };